export const controlTypes = {
    prev: 'prev',
    next: 'next'
};
